import { useEffect } from "react";

const SITE = "https://styrerom.murphy.no";
const OG_IMAGE = `${SITE}/og-image.jpg`;
const DEFAULT_DESC =
  "Digitalt styrerom for norske selskaper: aksjeeierbok, aksjekjøpsavtaler, styremøter, oppgaver og nøkkeltall fra regnskapssystemet. 199 kr per måned.";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function Seo({ title, description, path = "" }) {
  const desc = description || DEFAULT_DESC;
  const fullTitle = title ? `${title} — Murphy Styrerom` : "Murphy Styrerom — styreportal for norske selskaper";
  const url = `${SITE}${path}`;

  useEffect(() => {
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:site_name", "Murphy Styrerom");
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", OG_IMAGE);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    setMeta("name", "twitter:image", OG_IMAGE);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [fullTitle, desc, url]);

  return null;
}
